angular.module('elfium').directive('userList', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        controller: 'userController',
        templateUrl: elfiumUrlService.getTemplateUrl('user', 'userList')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/user/userList.ts